import {Store} from '../classes/store';
import {ProjectModule} from '../../../resources/module/project-module.interface';
import {Injectable} from '@angular/core';
import {ApiLegacyService} from '../../../services/api/api.service';

import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProjectModuleStore extends Store<ProjectModule> {

  /** Constructor. */
  constructor(
    private api: ApiLegacyService
  ) {
    super();
  }

  update(updateItem) {
    // Update the store and get the full item
    const fullItem = super.update(updateItem);

    // Add needed data
    updateItem.projectId = fullItem.projectId;
    updateItem.versionId = fullItem.versionId;

    // Pass the new data to the API
    this.api.updateModuleNoLoader(updateItem);

    return fullItem;
  }

  delete(deleteId) {
    // Update the store and get the full item
    const fullItem = super.delete(deleteId);

    // Pass the new data to the API
    this.api.deactivateModule(fullItem);

    return fullItem;
  }

  insert(module) {
    return this.api.createModule(module).pipe(map((insertedModule: ProjectModule) => {
      super.insert(insertedModule);
      return insertedModule;
    }));
  }

}
